import {loadScript} from './index'

export class WxSdk {
  constructor() {
  }

  /**
   * 动态加载wx JSSDK
   * @returns Promise
   */
  loadWxJsSdk() {
    return loadScript('wx', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js')
  }
}
